import React, { useState } from "react";
import { Link } from "react-router-dom";

const strategies = [
  {
    name: "Покрытый колл (Covered Call)",
    difficulty: "Новичок",
    type: "Доходная",
    description: "Продажа колл-опциона на уже принадлежащие акции. Используется для получения дохода в боковом рынке.",
    example: "Инвестор владеет 100 акциями и продаёт колл с ближним страйком, чтобы заработать премию.",
    payoff: "Ограниченная прибыль, ограниченный риск (владение акцией)."
  },
  {
    name: "Защитный пут (Protective Put)",
    difficulty: "Новичок",
    type: "Хеджирующая",
    description: "Покупка пут-опциона на уже имеющийся актив для защиты от падения цены.",
    example: "Инвестор покупает пут для защиты своего портфеля акций от коррекции.",
    payoff: "Ограниченный убыток, неограниченная прибыль."
  },
  {
    name: "Стрэддл (Straddle)",
    difficulty: "Продвинутый",
    type: "Спекулятивная",
    description: "Одновременная покупка колл и пут опционов с одинаковым страйком и сроком. Выгодна при высокой волатильности.",
    example: "Трейдер ожидает сильное движение акций, но не знает направление — использует стрэддл.",
    payoff: "Потери ограничены премиями, прибыль не ограничена при сильном движении."
  },
  {
    name: "Стрэнгл (Strangle)",
    difficulty: "Продвинутый",
    type: "Спекулятивная",
    description: "Покупка колл и пут с разными страйками. Более дешевая альтернатива стрэддлу.",
    example: "Инвестор ожидает движение, но хочет снизить премию за вход — выбирает стрэнгл.",
    payoff: "Прибыль при сильном движении цены, потери ограничены премиями."
  },
  {
    name: "Железный кондор (Iron Condor)",
    difficulty: "Опытный",
    type: "Доходная",
    description: "Комбинация бычьего и медвежьего спрэдов. Стратегия на стабильность цены.",
    example: "Инвестор считает, что акции останутся в диапазоне и использует кондор для извлечения прибыли.",
    payoff: "Ограниченная прибыль и убыток. Идеален для спокойного рынка."
  },
  {
    name: "Бычий спрэд (Bull Call Spread)",
    difficulty: "Новичок",
    type: "Спекулятивная",
    description: "Покупка колл и продажа колл с более высоким страйком. Ограниченная прибыль и риск.",
    example: "Ожидая умеренный рост, трейдер применяет бычий спрэд.",
    payoff: "Ограниченная прибыль и убыток."
  },
  {
    name: "Медвежий спрэд (Bear Put Spread)",
    difficulty: "Новичок",
    type: "Спекулятивная",
    description: "Покупка пут и продажа пут с более низким страйком. Ожидание снижения цены актива.",
    example: "При ожидании падения, инвестор реализует медвежий спрэд.",
    payoff: "Ограниченная прибыль и убыток."
  }
];

export default function OptionStrategies() {
  const [difficulty, setDifficulty] = useState("Все");
  const [type, setType] = useState("Все");

  const filtered = strategies.filter(
    (s) =>
      (difficulty === "Все" || s.difficulty === difficulty) &&
      (type === "Все" || s.type === type)
  );

  const difficulties = ["Все", ...new Set(strategies.map((s) => s.difficulty))];
  const types = ["Все", ...new Set(strategies.map((s) => s.type))];

  return (
    <div style={{ fontFamily: "sans-serif", padding: "2rem", maxWidth: "900px", margin: "0 auto" }}>
      <Link to="/" style={{ color: "#0070f3" }}>← Вернуться на главную</Link>
      <h1 style={{ textAlign: "center", fontSize: "2rem", marginBottom: "1rem" }}>Опционные Стратегии</h1>
      <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginBottom: "1.5rem", flexWrap: "wrap" }}>
        <select value={difficulty} onChange={(e) => setDifficulty(e.target.value)}>
          {difficulties.map((d, i) => (
            <option key={i} value={d}>{d}</option>
          ))}
        </select>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          {types.map((t, i) => (
            <option key={i} value={t}>{t}</option>
          ))}
        </select>
      </div>
      <div style={{ display: "grid", gap: "1.25rem" }}>
        {filtered.map((s, i) => (
          <div key={i} style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "1rem", background: "#f9f9f9" }}>
            <h3>{s.name}</h3>
            <p><strong>Тип:</strong> {s.type} | <strong>Уровень:</strong> {s.difficulty}</p>
            <p>{s.description}</p>
            <p><strong>Пример:</strong> {s.example}</p>
            <p><strong>Профиль доходности:</strong> {s.payoff}</p>
          </div>
        ))}
      </div>
    </div>
  );
}